import PropTypes from "prop-types"
import classnames from "classnames"
import { formatLongDate } from "helpers/formatters/dates"
import DailyDetails from "./components/daily-details"
import ContributorsDetails from "modules/beta-contributors"
import "./style.scss"

function AnalyzeBetaDetails({
  selectedDate,
  selected,
  selectedValue,
  details,
  viewType,
  displayType,
  displayTypeName,
  order,
  show,
  hide,
  sort,
  drift,
  openSecurityProfile,
  contributorsGrouping,
  setContributorsGrouping,
  showGroup,
  hideGroup,
  selectedGroup,
  selectedOption,
  contentSetId,
  groupSort,
  groupOrder,
  toggleShowNotHeld,
}) {
  return <div className={classnames("modules_analyze-beta-details")}>
    <h4 className="header"><span>As of {formatLongDate(selectedDate)}</span></h4>
    {!selected
      ? <DailyDetails {...{
          drift,
          viewType,
          displayTypeName,
          data: details,
          factorTable: displayType !== "total" && displayType !== "factors",
          show,
          groupSort,
          groupOrder,
        }}
      />
      : <ContributorsDetails {...{
          viewType,
          openSecurityProfile,
          showGroup,
          hideGroup,
          selectedGroup,
          hide,
          sort,
          order,
          selected,
          selectedValue,
          selectedDate,
          setContributorsGrouping,
          contributorsGrouping,
          selectedOption,
          contentSetId,
          toggleShowNotHeld,
          details,
          show,
          groupOrder,
        }}
      />}
  </div>
}

AnalyzeBetaDetails.propTypes = {
  selectedDate: PropTypes.string,
  selected: PropTypes.object,
  selectedValue: PropTypes.number,
  details: PropTypes.array,
  viewType: PropTypes.string,
  displayType: PropTypes.string,
  order: PropTypes.object,
  show: PropTypes.func,
  hide: PropTypes.func,
  sort: PropTypes.func,
  drift: PropTypes.object,
  openSecurityProfile: PropTypes.func,
  contributorsGrouping: PropTypes.object,
  setContributorsGrouping: PropTypes.func.isRequired,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  selectedOption: PropTypes.object.isRequired,
  contentSetId: PropTypes.string,
  displayTypeName: PropTypes.string.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  groupSort: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  toggleShowNotHeld: PropTypes.func.isRequired,
}

export default AnalyzeBetaDetails
